// extracted by mini-css-extract-plugin
export default {"link":"MenuLink_link__tVeFK","link_active":"MenuLink_link_active__Zix9q","fill":"MenuLink_fill__l8VGQ"};